import React, { useEffect, useRef } from "react";

function CartSuccessIcon() {
  return (
    <span className="shopNotice__cartMark" aria-hidden="true">
      <svg width="72" height="72" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.732 17.3366C21.732 17.3366 22.612 16.7899 23.0654 15.9633L27.8387 7.30992C28.332 6.42992 27.692 5.33659 26.6787 5.33659H6.94536L5.69203 2.66992H1.33203V5.33659H3.9987L8.7987 15.4566L6.9987 18.7099C6.02536 20.4966 7.30536 22.6699 9.33203 22.6699H25.332V20.0033H9.33203L10.7987 17.3366H20.732ZM8.21203 8.00326H24.412L20.732 14.6699H11.372L8.21203 8.00326ZM9.33203 24.0033C7.86536 24.0033 6.6787 25.2033 6.6787 26.6699C6.6787 28.1366 7.86536 29.3366 9.33203 29.3366C10.7987 29.3366 11.9987 28.1366 11.9987 26.6699C11.9987 25.2033 10.7987 24.0033 9.33203 24.0033ZM22.6654 24.0033C21.1987 24.0033 20.012 25.2033 20.012 26.6699C20.012 28.1366 21.1987 29.3366 22.6654 29.3366C24.132 29.3366 25.332 28.1366 25.332 26.6699C25.332 25.2033 24.132 24.0033 22.6654 24.0033Z"
          fill="#1b1b1b"
        />
      </svg>
      <span className="shopNotice__cartCheck">
        <svg width="15.4" height="15.4" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path
            d="M2.5 7.2L5.4 10.1L11.5 3.9"
            stroke="#1b1b1b"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </span>
  );
}

function SuccessTick() {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="43" cy="43" r="31.875" fill="#C5D01E" />
      <path
        d="M31.5 43.5L39.2 51.2L55.5 34.8"
        stroke="#1b1b1b"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FailureIcon() {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="43" cy="43" r="31.875" fill="#E53935" />
      <path
        d="M32 32L54 54"
        stroke="#1b1b1b"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M54 32L32 54"
        stroke="#1b1b1b"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
}

function noticeIcon(variant) {
  if (variant === "cart") return <CartSuccessIcon />;
  if (variant === "failure") return <FailureIcon />;
  return <SuccessTick />;
}

function isLargeNoticeCard(variant) {
  return variant === "cart" || variant === "failure" || variant === "success";
}

function ShopNoticeModal({
  show,
  message = "Item removed from cart.",
  onHide,
  duration = 2200,
  dismissible = true,
  variant = "default",
}) {
  const onHideRef = useRef(onHide);
  onHideRef.current = onHide;

  useEffect(() => {
    if (!show || !duration) return undefined;
    const timer = window.setTimeout(() => {
      onHideRef.current?.();
    }, duration);
    return () => window.clearTimeout(timer);
  }, [duration, show]);

  if (!show) return null;

  return (
    <div className="shopNotice" role="status" aria-live="polite">
      {dismissible ? (
        <button
          type="button"
          className="shopNotice__backdrop"
          onClick={onHide}
          aria-label="Dismiss"
        />
      ) : (
        <div className="shopNotice__backdrop" aria-hidden="true" />
      )}
      <div
        className={`shopNotice__card${
          isLargeNoticeCard(variant) ? " shopNotice__card--cart" : ""
        }${
          variant === "success" || variant === "failure"
            ? " shopNotice__card--auth"
            : ""
        }`}
      >
        {noticeIcon(variant)}
        <p className="shopNotice__text">{message}</p>
      </div>
    </div>
  );
}

export default ShopNoticeModal;
